import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {Actions} from '../AppConstants';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';


@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.css'],
    standalone: false
})
export class ConfirmationModalComponent implements OnInit, AfterViewInit {

    @Input()
    question = '';

    @Input()
    body = '';

    @ViewChild('normModal', {static: true}) bsShowModal: TemplateRef<any>;

    @Input()
    title = '';

    @Input()
    confirmText = 'yes';

    @Input()
    cancelText = '';

    @Input()
    hideCloseButton: boolean = false;

    @Output()
    emitData: EventEmitter<any> = new EventEmitter();

    makeSelection(confirm: any) {
        this.bsModalRef.hide();
        this.emitData.next(new Actions('confirm', confirm));
    }

    constructor(public bsModalRef: BsModalRef, private modalService: BsModalService) {

    }

    openModal() {
        this.bsModalRef = this.modalService.show(this.bsShowModal);
    }

    ngOnInit() {}

    ngAfterViewInit() {
       // this.openModal();
    }

}
